var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from "react";
import { Redirect } from "react-router-dom";
import { useStore } from "effector-react";
import { $userRoles } from "frontend/src/domain/session/model";
import { Role } from "frontend/src/shared/types/role";
import { mapViewerRoleToDefaultPath } from "../paths/lib";
var canViewRoute = function (roles, routeRoles) {
    var _a;
    var UserRoleToViewerRoleMap = (_a = {},
        _a[Role.Guest] = roles.guest,
        _a[Role.Admin] = roles.admin,
        _a[Role.BusinessOwner] = roles.business.owner,
        _a[Role.BusinessEmployee] = roles.business.employee,
        _a[Role.Rightholder] = roles.rightholder,
        _a[Role.MusicEditor] = roles.musicEditor,
        _a);
    return routeRoles.some(function (role) { return UserRoleToViewerRoleMap[role]; });
};
export var withRole = function (Component, roles) {
    return function (props) {
        var viewerRole = useStore($userRoles);
        if (!canViewRoute(viewerRole, roles)) {
            return React.createElement(Redirect, { to: mapViewerRoleToDefaultPath(viewerRole) });
        }
        return React.createElement(Component, __assign({}, props));
    };
};
